export default __webpack_public_path__ + "static/media/PowerPoint-Logo.f0f99bcb.svg";